// extracted by mini-css-extract-plugin
module.exports = {"menu":"UserPopup_menu__2yugT","menuItem":"UserPopup_menuItem__yaw_D"};